import React, { useEffect, useState } from 'react';
import { UiImage } from '@open-stack/ui';

type ProductIconInput = {
    icon: any;
};

const fallbackIcon = require(`!raw-loader!./fallback.svg`).default;

const icons = {};
const iconPromises = {};

export function ProductIcon({ icon }: ProductIconInput) {
    const isSvg = icon && !icon?.startsWith('http');
    const [svg, setSvg] = useState(icons[icon] || '');

    async function loadIcon() {
        try {
            iconPromises[icon] =
                iconPromises[icon] || fetch(require(`./icons/${icon}.svg`)).then((result) => result.text());
            icons[icon] = await iconPromises[icon];
            setSvg(icons[icon]);
        } catch (error) {}
    }

    useEffect(() => {
        if (isSvg) {
            loadIcon();
        }
    }, [isSvg]);

    return isSvg ? <span dangerouslySetInnerHTML={{ __html: svg || fallbackIcon }} /> : <UiImage src={icon} />;
}
